import app from './../index';
import Pageable from './../Pageable';

export default class LagerController {

  constructor($routeParams) {
    'ngInject';

    this.searchText = "";
    this.nurAktiv = $routeParams.nurAktiv;
    this.serviceBase = app.serviceBase;

    this.refresh();
  }

  refresh() {
    this.pageable = new Pageable(app.api.artikel);

    let params = {
      name: this.searchText,
      nurAktiv: this.nurAktiv
    };

    this.pageable.refresh(params);
  }

  bestandAktualisieren() {
    app.api.artikel.lagerBestandAktualisieren()
      .$promise
      .then(() => {
        this.refresh();
      });
  }
}

LagerController.$inject = ['$routeParams'];



// WEBPACK FOOTER //
// ./app/artikel/lagerController.js